import { createSelector } from 'reselect';

const getReleaseManagementState = (state) => state.releaseManagementReducer;

const getReleaseDetailsData = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.releaseDetailsData
  );
  
  const getselectedStatus = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.selectedStatus
  );

  const getRejectionReason = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.rejection_reason
  );

  const getLoading = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.loading
  );


  const getError = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.error
  );

  const getInformatioAlert = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.informationAlert
  )

  const getReleaseNotes = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.releaseNotesText
  )

  const getReleaseNotesLoader = createSelector(
    [getReleaseManagementState],
    (releaseManagement) => releaseManagement.notesDownloadReducerLoader
  )

  export {
    getReleaseDetailsData,
    getselectedStatus,
    getLoading,
    getError,
    getRejectionReason,
    getInformatioAlert,
    getReleaseNotes,
    getReleaseNotesLoader,
  };